import { endpoints } from '@/services/endpoints';
import { axiosGetRequest } from '@/services/Request';
import { useQuery } from '@tanstack/react-query';
import { AppCard } from '@/components/ui/AppCard';
import { AppBarChart } from '@/components/charts/pieChart/AppBarChart';

export default function TicketChartsByMonth() {
  const { data: ticketsPerMonth, isLoading } = useQuery({
    queryKey: ['tickets-per-month'],
    queryFn: () => axiosGetRequest(endpoints.getTicketPerMonth),
    select: ticketsPerMonth => ticketsPerMonth.data,
  });
  const config = {
    count: {
      label: 'Total tickets',
      color: '#0D9373',
    },
    April: {
      label: 'April',
      color: '#10B981',
    },
    Feb: {
      label: 'February',
      color: '#34D399',
    },
    March: {
      label: 'March',
      color: '#3B82F6',
    },
    May: {
      label: 'May',
      color: '#6EE7B7',
    },
  };

  return (
    <AppCard>
      <h3 className="mb-4 text-base font-semibold text-coal-900">Tickets per Month</h3>
      <AppBarChart
        chartData={ticketsPerMonth}
        dataKey="count"
        nameKey="month"
        config={config}
        isLoading={isLoading}
      />
    </AppCard>
  );
}
